import classNames from "classnames";
import styles from "../styles/login.module.scss";
import {observer} from "mobx-react";
import {shareState} from "../../../app/share-state";
import {Image} from "../../../components/image/image";
import {XRequestParams} from "../../../icons/x-icon";
import {CalendarImageRequestParams} from "../../../icons/calendar";
import {useRef, useState} from "react";
import {APP_CONST} from "../../../consts";
import {LoginWidgetDateOfBirthMobileDatePicker} from "./login.widget.date-of-birth-mobile-date-picker";

export const LoginWidgetDateOfBirth = observer(({controller}) => {
  const {state: {dateOfBirth, dateOfBirthHasError}} = controller;
  const hiddenInputRef = useRef(null);
  const isAndroidWebView = shareState.appType === APP_CONST.PLATFORMS.android;
  const [isMobilePickerOpen, setIsMobilePickerOpen] = useState(false);

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const displayValue = formatDateForDisplay(dateOfBirth);

  const handleDivClick = () => {
    if (isAndroidWebView) {
      setIsMobilePickerOpen(true);
      return;
    }
    if (hiddenInputRef.current) {
      hiddenInputRef.current.showPicker?.() || hiddenInputRef.current.focus();
    }
  };

  const handleDateChange = (e) => {
    controller.setDateOfBirth(e.target.value);
    controller.validateDateOfBirthOnBlur();
  };

  const handleMobilePickerConfirm = (value) => {
    controller.setDateOfBirth(value);
    controller.validateDateOfBirthOnBlur();
    setIsMobilePickerOpen(false);
  };

  const handleMobilePickerCancel = () => {
    setIsMobilePickerOpen(false);
  };

  const errorIconProps = {
    className: classNames(
      styles.date_of_birth_validation_icon,
      {[styles.date_of_birth_validation_icon_visible]: dateOfBirthHasError}
    ),
    src: new XRequestParams(16, 16)
  };

  const calendarIconProps = {
    className: classNames(styles.date_of_birth_calendar_icon),
    src: new CalendarImageRequestParams(20, 20)
  };

  return (
    <div className={classNames(styles.date_of_birth_container)}>
      <label className={classNames(styles.date_of_birth_label)}>
        {shareState.termsUtils.terms.BOLAO_ATLEAST_18REQUIRED}
      </label>
      <div
        className={classNames(
          styles.date_of_birth_input_custom,
          {[styles.date_of_birth_input_error]: dateOfBirthHasError}
        )}
        onClick={handleDivClick}
      >
        <span className={classNames(styles.date_of_birth_text)}>
          {displayValue || "DD/MM/YYYY"}
        </span>
        <Image {...errorIconProps}/>
        <Image {...calendarIconProps}/>
      </div>
      <input
        ref={hiddenInputRef}
        type="date"
        value={dateOfBirth}
        onChange={handleDateChange}
        onBlur={() => controller.validateDateOfBirthOnBlur()}
        className={classNames(styles.date_of_birth_input_hidden)}
        tabIndex={isAndroidWebView ? -1 : 0}
      />
      {isAndroidWebView && isMobilePickerOpen && (
        <LoginWidgetDateOfBirthMobileDatePicker
          dateOfBirth={dateOfBirth}
          onConfirm={handleMobilePickerConfirm}
          onCancel={handleMobilePickerCancel}
        />
      )}
    </div>
  )
});
